import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { videoTypesDefinitions } from "../../imports";
import { VideoPreview } from "../FormElements";
import { H2RButton } from "../../imports";
import { sToStringFormatted } from "../helpers/time";
import { faRefresh, faVolumeHigh, faVolumeMute } from "@fortawesome/free-solid-svg-icons";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Name"
				placeholder="Video name"
				value={cue.name}
				onChange={(value) => {
					onUpdate({ name: value });
				}}
			/>

			<H2RSelect
				selected={cue.backgroundFit || "cover"}
				label="Video size"
				options={[
					{
						label: "Grow to fill screen",
						value: "cover",
					},
					{
						label: "Shrink to fit",
						value: "contain",
					},
				]}
				onChange={(value) => {
					return onUpdate({ backgroundFit: value });
				}}
			/>

			<H2RSelect
				selected={cue.filename}
				label="Video"
				options={
					media.length === 0
						? [
								{
									label: "Add videos in the Media tab",
									value: ``,
									disabled: true,
								},
						  ]
						: [
								...media
									.filter((item) =>
										videoTypesDefinitions.includes(item?.mimetype)
									)
									.sort((a, b) => {
										if(a.originalname.toUpperCase() < b.originalname.toUpperCase()) { return -1; }
										if(a.originalname.toUpperCase() > b.originalname.toUpperCase()) { return 1; }
										return 0;
									})
									.map((item) => {
										return {
											label: item.originalname,
											value: item.filename,
										};
									}),
						  ]
				}
				onChange={(value) => {
					return onUpdate({ filename: value });
				}}
			/>

			<VideoPreview video={cue.filename} />

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Controls
			</span>
			<div className="flex space-x-2">
				<H2RButton
					checked={cue.loop || false}
					text={cue.loop ? "Looping" : "Loop"}
					colour={cue.loop ? "main" : "dark"}
					icon={faRefresh}
					size="small"
					onClick={() => {
						return onUpdate({ loop: !cue.loop });
					}}
				/>
				<H2RButton
					checked={cue.mute || false}
					text={cue.mute ? "Muted" : "Audio on"}
					colour={cue.mute ? "main" : "dark"}
					icon={cue.mute ? faVolumeMute : faVolumeHigh}
					size="small"
					onClick={() => {
						return onUpdate({ mute: !cue.mute });
					}}
				/>
			</div>

			<H2RInput
				type="range"
				label="Volume"
				colour="dark"
				value={cue.volume || 100}
				labelValue={cue.volume || 100}
				max={100}
				min={0}
				step={1}
				onChange={(change) => {
					onUpdate({ volume: change });
				}}
			/>

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Duration
			</span>
			<div className="text-sm flex space-x-2 font-mono">
				<span>{sToStringFormatted(parseFloat(cue.currentTime))}</span>
				<span className="text-gray-600">/</span>
				<span>{sToStringFormatted(parseInt(cue.length))}</span>
			</div>

			<H2RSelect
				label="On end"
				selected={cue.onEnd || "go_offair"}
				onChange={(value) => {
					onUpdate({ onEnd: value });
				}}
				options={[
					{
						label: "Go offair",
						value: "go_offair",
					},
					{
						label: "Hold last frame",
						value: "hold_last",
					},
					{
						label: "Hold first frame",
						value: "hold_first",
					},
				]}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
}) => {
	const endingSoon = cue.currentTime >= cue.length - 5;
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{cue.name || "Video"}</span>
			<span className="font-mono">
				<span className="text-gray-100 opacity-40 px-2">•</span>
				{cue.currentTime !== 0 && (
					<>
					<span
						className={`text-sm ${
							endingSoon ? "text-red-400" : "text-gray-300"
						}`}
					>
						<span>{sToStringFormatted(parseFloat(cue.currentTime))}</span>
						<span className="text-gray-100 opacity-40 px-2">/</span>
					</span>
					<span
						className={`text-sm ${
							endingSoon ? "text-red-400" : "text-gray-300"
						}`}
					>
						<span>{sToStringFormatted(parseFloat(cue.length) - parseFloat(cue.currentTime))}</span>
						<span className="text-gray-100 opacity-40 px-2">/</span>
					</span>
					</>
				)}
				<span
					className={` text-sm ${
						endingSoon ? "text-red-400" : "text-gray-300"
					}`}
				>
					<span>{sToStringFormatted(parseInt(cue.length))}</span>
				</span>
			</span>
		</div>
	);
};
